import { StateTransitionsTable } from "@/components/stock/state-transitions-table";
import { useOrderStateTransitions } from "@/hooks/use-order-state-transitions";
import type { OrderPanelBaseProps } from "../../shared";

/**
 * The order's protocol: when it was raised, released, picked and signed off — the order's own
 * transitions merged with those of every picking round under it.
 *
 * Both levels together rather than the order's alone, because an order's states are derived from
 * its rounds: `update_order_state` recomputes the column whenever a round moves, so a list of
 * order transitions with the rounds removed would show effects with their causes taken out.
 */
export function OrderProtocol({ orderId }: OrderPanelBaseProps) {
	/** Query */
	const { stateTransitions, isLoading, refetch, queryKey } = useOrderStateTransitions(orderId);

	/** Render */
	return (
		<StateTransitionsTable
			stateTransitions={stateTransitions}
			isLoading={isLoading}
			refetch={refetch}
			queryKey={queryKey}
			persistenceKey="order-protocol-table"
		/>
	);
}
